go-link {
  .external-link-icon {
    height: 0.9em;
    fill: currentColor;
    transform: translate(10%, 15%);
    margin-left: 0.25em;
  }

  .expand {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }
}
